module.exports = __webpack_public_path__ + "static/concierge-bus-dac556adb0f87259670b84e98c937555.jpg";